import React from "react";
import { MapPin, Phone, Mail } from "lucide-react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function RecapitiEPosizione() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  const contactInfo = [{
    icon: Mail,
    label: "Email",
    value: "info@loraserramenti.it",
    href: "mailto:info@loraserramenti.it"
  }, {
    icon: Phone,
    label: "Telefono",
    value: "+39 334 9255303",
    href: "tel:+393349255303"
  }, {
    icon: MapPin,
    label: "Indirizzo",
    value: "Via Paolo Braccini 37/b, Ciriè",
    href: "https://maps.google.com/?q=Via+Paolo+Braccini+37/b,+Ciriè",
    newTab: true
  }];
  return <section id="recapiti-e-posizione" ref={ref} className={cn("bg-background py-24 transition-opacity duration-700", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10")}>
      <div className="max-w-7xl mx-auto px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start">
          {}
          <div className="flex flex-col justify-center h-full">
            <h2 className="text-3xl md:text-4xl font-bold text-primary mb-8">
              Recapiti
            </h2>
            <p className="text-muted-foreground mb-10 text-lg leading-relaxed max-w-md">
              Siamo a tua disposizione per qualsiasi informazione. Contattaci per
              richiedere un preventivo o vieni a trovarci nella nostra sede.
            </p>

            <div className="space-y-8">
              {contactInfo.map((item, i) => <div key={i} data-index={i} className="flex items-start gap-5 group">
                  <div className="flex-shrink-0 mt-1">
                    <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center text-primary group-hover:bg-primary group-hover:text-white transition-colors duration-300">
                      <item.icon className="w-6 h-6" />
                    </div>
                  </div>
                  <div className="flex flex-col">
                    <span className="text-sm font-medium text-muted-foreground mb-1">
                      {item.label}
                    </span>
                    <Link to={item.href} newTab={item.newTab} className="text-xl font-semibold text-foreground hover:text-primary transition-colors">
                      {item.value}
                    </Link>
                  </div>
                </div>)}
            </div>
          </div>

          {}
          <div className="w-full h-[400px] lg:h-[500px] rounded-2xl overflow-hidden shadow-lg bg-muted relative group">
            <iframe title="Mappa Sede Lora Serramenti" width="100%" height="100%" frameBorder="0" scrolling="no" marginHeight={0} marginWidth={0} src="https://maps.google.com/maps?q=Via%20Paolo%20Braccini%2037%2Fb%2C%20Ciri%C3%A8&t=&z=15&ie=UTF8&iwloc=&output=embed" className="w-full h-full transition-all duration-500 ease-in-out" style={{
            border: 0
          }} allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>
            
            {}
            <div className="absolute inset-0 pointer-events-none flex items-center justify-center bg-black/5 opacity-0 group-hover:opacity-0 transition-opacity duration-300">
              <span className="sr-only">Mappa interattiva</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}